import { doc, setDoc, onSnapshot, serverTimestamp, type Unsubscribe } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { useUserPatternStore } from '@/stores/userPatternStore';
import type { UserPattern } from '@/types';
import type { CompletionEvent } from '@/stores/userPatternStore';
import { toDate } from './firestoreDate';
import { logSyncError } from './syncErrors';

function patternDoc(uid: string) {
  return doc(db, 'users', uid, 'patterns', 'main');
}

export function startPatternSync(uid: string): Unsubscribe {
  return onSnapshot(
    patternDoc(uid),
    (snap) => {
      if (!snap.exists()) return;
      const data = snap.data();
      const rawPattern = data.pattern as Record<string, unknown> | undefined;
      const pattern: UserPattern = {
        peakStart: (rawPattern?.peakStart as string | undefined) ?? '09:00',
        peakEnd: (rawPattern?.peakEnd as string | undefined) ?? '12:00',
        midStart: (rawPattern?.midStart as string | undefined) ?? '14:00',
        midEnd: (rawPattern?.midEnd as string | undefined) ?? '17:00',
        lowWindows: (rawPattern?.lowWindows as string[] | undefined) ?? [],
        avgCompletionRate: (rawPattern?.avgCompletionRate as number | undefined) ?? 0,
        skipPatterns: (rawPattern?.skipPatterns as UserPattern['skipPatterns'] | undefined) ?? [],
        preferredTaskDuration: (rawPattern?.preferredTaskDuration as number | undefined) ?? 30,
        updatedAt: rawPattern?.updatedAt != null ? toDate(rawPattern.updatedAt) : new Date(),
      };
      const completions: CompletionEvent[] =
        (data.completions as CompletionEvent[] | undefined) ?? [];
      useUserPatternStore.setState({ pattern, completions });
    },
    logSyncError('patternSync', uid),
  );
}

export async function writePattern(
  uid: string,
  pattern: UserPattern,
  completions: CompletionEvent[],
): Promise<void> {
  await setDoc(patternDoc(uid), { pattern, completions, serverUpdatedAt: serverTimestamp() });
}
